






















































import { Component, Vue, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { UnavailableStatus } from "../../../store/mobile/types";

const Mobile = namespace("mobile");

@Component
export default class UnavailablePicker extends Vue {
	@Mobile.Mutation setOnDuty: any;
	@Mobile.Action setUnavailableReason: any;
	@Mobile.Getter("getGuardId") guardId: number;
	@Mobile.Getter("getUnavailableStatuses")
	unavailableStatuses: UnavailableStatus[];

	public unavailableReason: string = "";
	public selectedStatusId: number = 0;
	public showMessage: boolean = false;

	@Emit("confirm")
	public emitConfirm(showComponentAfterEmit: boolean) {
		return showComponentAfterEmit;
	}

	@Emit("cancel")
	public emitCancel(showComponentAfterEmit: boolean) {
		return showComponentAfterEmit;
	}

	public breakReason(selectedButtonValue) {
		this.showMessage = false;
		this.selectedStatusId = selectedButtonValue;
	}

	private get selectedUnavailableStatus(): UnavailableStatus {
		return this.unavailableStatuses.find(el => {
			return el.statusID == this.selectedStatusId;
		});
	}

	public cancel() {
		this.showMessage = false;
		this.selectedStatusId = 0;
		this.emitCancel(false);
	}

	public confirm() {
		if (this.selectedStatusId === 0) {
			// User not selected a valid unavailable reason, so try to find a reason that contains the word 'unavailable' or 'other'
			var statusNamedUnavailable: UnavailableStatus | null = this.unavailableStatuses.find(el => {
				const unavailableName = el.name.toLowerCase();
				if (unavailableName.indexOf("unavailable") > -1 || unavailableName.indexOf("other") > -1) {
					return el;
				} else {
					return null;
				}
			});

			if (statusNamedUnavailable !== null && typeof statusNamedUnavailable !== "undefined") {
				this.selectedStatusId = statusNamedUnavailable.statusID;
			} else {
				// If we couldn't find one, need to tell the user what's wrong
				this.showMessage = true;
				return;
			}
		}

		const payload = {
			unavailableStatusId: this.selectedUnavailableStatus.statusID,
			unavailableReason: this.unavailableReason
		};

		this.showMessage = false;
		this.selectedStatusId = 0;
		this.setUnavailableReason(payload);
		this.setOnDuty(false);
		this.emitConfirm(false);

		// Reset the reason
		this.unavailableReason = "";
	}
}
